import { atom } from 'recoil';

export const toastMessageState = atom({
  key: "toastMessageState",
  default:null
});
